import {
  collection,
  doc,
  getDoc,
  getDocs,
  orderBy,
  query,
  setDoc,
  serverTimestamp,
  where,
} from "firebase/firestore";

function snapshotId(league, weight) {
  return `${(league || "").replace(/\//g, "_")}__${(weight != null
    ? String(weight)
    : ""
  ).replace(/\//g, "_")}`;
}

/**
 * Saves the current rankings (order by Skill) for each league+weight that the given athletes belong to.
 * Call this BEFORE updating skills so the rankings page can show "↑5" / "↓2" badges.
 * @param {FirebaseFirestore} db - Firestore instance
 * @param {string[]} athleteIds - Athlete document IDs (e.g. [wrestlerId, opponentId])
 */
export async function saveRankingsSnapshotForAthletes(db, athleteIds) {
  if (!db || !Array.isArray(athleteIds) || athleteIds.length === 0) return;
  const seenIds = new Set();
  const seenKeys = new Set();
  const pairs = [];
  for (const id of athleteIds) {
    if (!id || seenIds.has(id)) continue;
    seenIds.add(id);
    try {
      const ref = doc(db, "athletes", id);
      const snap = await getDoc(ref);
      if (!snap.exists()) continue;
      const data = snap.data();
      const league =
        data.RankLeague != null ? String(data.RankLeague).trim() : "";
      const weight =
        data.RankWeightClass != null ? String(data.RankWeightClass) : "";
      if (!league) continue;
      const key = `${league}\t${weight}`;
      if (seenKeys.has(key)) continue;
      seenKeys.add(key);
      pairs.push({ league, weight });
    } catch (_) {
      // skip this athlete
    }
  }
  for (const { league, weight } of pairs) {
    try {
      const constraints = [
        where("RankLeague", "==", league),
        where("RankWeightClass", "==", weight),
      ];
      let q = query(
        collection(db, "athletes"),
        ...constraints,
        orderBy("Skill", "desc")
      );
      let snap = await getDocs(q).catch(() => null);
      if (!snap || snap.empty) {
        q = query(collection(db, "athletes"), ...constraints);
        snap = await getDocs(q);
        const rows = [];
        snap.forEach((d) =>
          rows.push({ id: d.id, skill: d.data().Skill || 0 })
        );
        rows.sort((a, b) => b.skill - a.skill);
        const ranks = {};
        rows.forEach((r, idx) => {
          ranks[r.id] = idx + 1;
        });
        await setDoc(doc(db, "rankingsSnapshots", snapshotId(league, weight)), {
          league,
          weight,
          ranks,
          updatedAt: serverTimestamp(),
        });
      } else {
        const ranks = {};
        snap.docs.forEach((d, idx) => {
          ranks[d.id] = idx + 1;
        });
        await setDoc(doc(db, "rankingsSnapshots", snapshotId(league, weight)), {
          league,
          weight,
          ranks,
          updatedAt: serverTimestamp(),
        });
      }
    } catch (_) {
      // ignore per–league errors
    }
  }
}
